/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from 'react';
import dayjs from 'dayjs';
import { Group, Popover } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import { IconChevronDown, IconCalendar, IconCheck } from '@tabler/icons-react';
import { Button } from '../../styledComponents';
import { getDateNDaysAgo } from '../../../utils/global';
import styles from './CustomDatePicker.module.css';

const datepickerOptions = [
  { id: '1', label: 'Last 7d', value: 7 },
  { id: '2', label: 'Last 14d', value: 14 },
  { id: '3', label: 'Last 30d', value: 30 },
  { id: '4', label: 'Last 3mo', value: 90 },
  { id: '5', label: 'All Time', value: -1 },
  { id: '6', label: 'Custom Range', value: 0 },
];

type CustomDatePickerProps = {
  selectedDays: number;
  setSelectedDays: React.Dispatch<React.SetStateAction<number>>;
  dateRange: [Date | null, Date | null];
  setDateRange: (v: [Date | null, Date | null]) => any;
  showDatePicker: boolean;
  setShowDatePicker: React.Dispatch<React.SetStateAction<boolean>>;
};

export default function CustomDatePicker({
  selectedDays,
  setSelectedDays,
  dateRange,
  setDateRange,
  showDatePicker,
  setShowDatePicker,
}: CustomDatePickerProps) {
  const [tempSelectedDays, setTempSelectedDays] = useState(selectedDays);
  const [tempDateRange, setTempDateRange] = useState<any>(selectedDays === 0 ? dateRange : []);

  const handleSelectDateRange = (days: number) => {
    if (days === -1) {
      setDateRange([null, null]);
    } else if (days === 0) {
      setDateRange(tempDateRange);
    } else {
      const from = getDateNDaysAgo(days);
      const to = new Date();
      setDateRange([from, to]);
    }
  };

  const handleApply = (days: number) => {
    if (days === 0) {
      handleSelectDateRange(days);
      setSelectedDays(days);
      setShowDatePicker(false);
    } else {
      setSelectedDays(days);
      setShowDatePicker(false);
      handleSelectDateRange(days);
    }
  };

  const handleCancel = () => {
    setSelectedDays(selectedDays);
    setDateRange(dateRange);
    setTempSelectedDays(selectedDays);
    setTempDateRange(selectedDays === 0 ? dateRange : []);
    setShowDatePicker(false);
  };

  const formatSelectedDate = () => {
    if (selectedDays === 0) {
      return `${dayjs(dateRange[0]).format('DD MMM YYYY')} - ${dayjs(dateRange[1]).format('DD MMM YYYY')}`;
    }
    return datepickerOptions?.find((option) => option.value === selectedDays)?.label;
  };

  return (
    <div className={styles.dateRangeDiv}>
      <Popover
        width="auto"
        position="bottom"
        classNames={{ dropdown: styles.dropDownContainer }}
        withArrow
        shadow="md"
        opened={showDatePicker}
        onClose={handleCancel}
        closeOnClickOutside={false}
      >
        <Popover.Target>
          <p onClick={() => setShowDatePicker(true)} className={styles.selectedDate}>
            <IconCalendar size={24} strokeWidth={1.5} />
            <span>{formatSelectedDate()}</span>
            <IconChevronDown size={24} strokeWidth={1.5} />
          </p>
        </Popover.Target>
        <Popover.Dropdown>
          <div className={styles.datepickerDrodown}>
            <div className={styles.leftContainer}>
              <div className={styles.checkOptions}>
                {datepickerOptions?.map((option) => (
                  <p
                    key={option.id}
                    onClick={() => {
                      if (option.value !== 0) {
                        handleApply(option.value);
                        setTempSelectedDays(option.value);
                      } else {
                        setTempSelectedDays(option.value);
                      }
                    }}
                    style={{ color: tempSelectedDays === option?.value ? 'var(--saral-purple)' : 'var(--black)' }}
                  >
                    {option.label}
                    {tempSelectedDays === option.value && (
                      <IconCheck size={22} strokeWidth={1.7} color="var(--saral-purple)" />
                    )}
                  </p>
                ))}
              </div>
              <div className={styles.buttonOption}>
                {datepickerOptions?.map((option) => (
                  <div
                    role="button"
                    tabIndex={0}
                    className={`${styles.buttonOptionChip} ${
                      tempSelectedDays === option?.value ? styles.buttonOptionChipSelected : ''
                    }`}
                    key={option.id}
                    onClick={() => {
                      if (option.value !== 0) {
                        handleApply(option.value);
                        setTempSelectedDays(option.value);
                      } else {
                        setTempSelectedDays(option.value);
                      }
                    }}
                    // style={{ color: tempSelectedDays === option?.value ? 'var(--saral-purple)' : 'var(--black)' }}
                  >
                    {option.label}
                  </div>
                ))}
              </div>
            </div>
            <div className={styles.rightContainer}>
              <div
              // style={{
              //   opacity: tempSelectedDays === 0 ? 1 : 0.4,
              //   pointerEvents: tempSelectedDays === 0 ? 'all' : 'none',
              // }}
              >
                <DatePicker
                  style={{ display: 'flex', justifyContent: 'center' }}
                  type="range"
                  value={tempDateRange}
                  onChange={(val) => {
                    setTempDateRange(val);
                    setTempSelectedDays(0);
                  }}
                />
              </div>
              {(tempDateRange[0] || tempDateRange[1]) && (
                <div className={styles.dateDisplayContainer}>
                  <div className={styles.dateDisplay}>
                    {tempDateRange[0] ? dayjs(tempDateRange[0]).format('DD-MM-YYYY') : 'N/A'}
                  </div>
                  <span>-</span>
                  <div className={styles.dateDisplay}>
                    {tempDateRange[1] ? dayjs(tempDateRange[1]).format('DD-MM-YYYY') : 'N/A'}
                  </div>
                </div>
              )}
              <div className={styles.buttonGroup}>
                {tempSelectedDays === 0 && (
                  <Group mt={20}>
                    <Button
                      fontSize="12px"
                      bgColor="white"
                      color="var(--dark-grey)"
                      style={{ flex: 1, border: '1px solid var(--dark-grey)' }}
                      onClick={handleCancel}
                    >
                      Cancel
                    </Button>
                    <Button
                      fontSize="12px"
                      bgColor="var(--saral-purple)"
                      style={{ flex: 1 }}
                      onClick={() => handleApply(0)}
                      disabled={tempSelectedDays === 0 && (tempDateRange[0] === null || tempDateRange[1] === null)}
                    >
                      Apply
                    </Button>
                  </Group>
                )}
              </div>
            </div>
          </div>
        </Popover.Dropdown>
      </Popover>
    </div>
  );
}
